import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/store.js'
import fxViewcomponents from '@/components/fxView'
//====================bank==================================================
import bank from '@/components/fxView/bank/bank'
//====================users=================================================
import login from '@/components/fxView/users/login'
import register from '@/components/fxView/users/register'
import twoFa from '@/components/fxView/users/2FA'
import profile from '@/components/fxView/users/profile'
import downloadplatform from '@/components/fxView/users/downloadplatform'
import forgotPassword from '@/components/fxView/users/forgot_password'
import notification from '@/components/fxView/users/user_notification'
import ResetPasswordFromHash from '@/components/fxView/users/ResetPasswordFromHash'
import pro from '@/components/fxView/users/pro'
import request_verify from '@/components/fxView/users/request_verify'
import dashboard from '@/components/fxView/users/dashboard'
import changeUserPassword from '@/components/fxView/users/change_password'
import zuluTrade from '@/components/fxView/zulutrade/zulutrade'
import welcome from '@/components/fxView/users/welcome'
//======================trading account=====================================
import later from '@/components/fxView/registerSteps/do_later'
import openOrderList from '@/components/fxView/tradingAccounts/open_orders_listing'
import openTradeList from '@/components/fxView/tradingAccounts/open_trades_listing'
import closeTradeList from '@/components/fxView/tradingAccounts/close_trades_listing'
import createAccountLive from '@/components/fxView/tradingAccounts/create_account_live'
import createAccountDemo from '@/components/fxView/tradingAccounts/create_account'
import rest_api from '@/components/fxView/tradingAccounts/rest_api'

import web_trade_link from '@/components/fxView/tradingAccounts/web_trade_link'
import web_trade_link_live from '@/components/fxView/tradingAccounts/web_trade_link_live'
import web_trade_link_new from '@/components/fxView/tradingAccounts/web_trade_link_new'



//=====================withdrawal================================================
import withdrawal from '@/components/fxView/withdrawal/withdrawal'
import withdrawalList from '@/components/fxView/withdrawal/withdrawal_listing'
//======================manage account=====================================
import accountList from '@/components/fxView/manageAccounts/account_list'
import changeLeverage from '@/components/fxView/manageAccounts/change_leverage'
import internalTransfer from '@/components/fxView/manageAccounts/internal_transfer'
import changePassword from '@/components/fxView/manageAccounts/change_password1'
import accountVerify from '@/components/fxView/manageAccounts/account-verify'
//=====================deposit================================================
import deposit from '@/components/fxView/deposit/deposit'
import depositList from '@/components/fxView/deposit/deposit_listing'
import depositTransaction from '@/components/fxView/deposit/deposit_transaction'
import paymentCallback from '@/components/fxView/deposit/paymentCallback'
//=====================Bonus================================================
import bonus from '@/components/fxView/bonus/bonus'
import bonusList from '@/components/fxView/bonus/bonus_list'
import removeBonus from '@/components/fxView/bonus/remove_bonus'
import bonusVerify from '@/components/fxView/bonus/bonus_verify'
//=====================supports================================================
import support from '@/components/fxView/supports/index'
import view from '@/components/fxView/supports/view'

import unauthorized from '@/components/fxView/unauthorized/unauthorized'
import pendingVerification from '@/components/fxView/unauthorized/pending_verification'
import failedTest from '@/components/fxView/unauthorized/failedTest'

//=====================tradinngTools page================================================
import subscriptionTool from '@/components/fxView/tradingtools/subscription_tool'
import market from '@/components/fxView/tradingtools/market'
import autoChartist from '@/components/fxView/tradingtools/autoChartist'
import signalCentre from '@/components/fxView/tradingtools/signalCentre'
import createSubTicket from '@/components/fxView/tradingtools/createSubTicket'
import api_documentation from '@/components/fxView/tradingtools/api_documentation'
import subscription_service_plan from '@/components/fxView/tradingtools/subscription_service_plan'
import subscription_verify from '@/components/fxView/tradingtools/subscription_verify'
import economic_calendar from '@/components/fxView/tradingtools/economic-calendar'
import vpsList from '@/components/fxView/tradingtools/vpsList'
import vpsDetail from '@/components/fxView/tradingtools/vpsDetail'
import tradeNews from '@/components/fxView/tradingtools/tradeNews'
import market_news from '@/components/fxView/tradingtools/market_news'
import market_insight from '@/components/fxView/tradingtools/market_insight'
import video_tutorials from '@/components/fxView/tradingtools/video_tutorials'

import tradertool_box from '@/components/fxView/tradingtools/tradertool_box'
import autochartist_scanner from '@/components/fxView/tradingtools/autochartist_scanner'

import {
  BANK, DASHBOARD, PROFILE, TWOFA, REQUEST_VERIFY, INDEX, NOTIFICATION, TRADER_CHANGE_PASSWORD, ACCOUNT_LIST, OPEN_TRADES, OPEN_ORDERS, WITHDRAWAL, WITHDRAWAL_LIST, DEPOSIT, DEPOSIT_LIST, PAYMENTCALLBACK, BONUS, BONUS_LIST, REMOVE_BONUS, SUPPORT, VIEW, CHANGE_LEVERAGE,
  INTERNAL_TRANSFER, ACCOUNT_VERIFY, LS_ROUTE_KEY, CREATE_DEMO_ACCOUNT, CREATE_LIVE_ACCOUNT
} from "@/consts"
Vue.use(Router)
const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'fxView.login',
      component: login
    },
    {
      path: '/register',
      name: 'fxView.register',
      component: register
    },
    {
      path: '/forgot-password',
      name: 'fxView.forgotPassword',
      component: forgotPassword
    },
    {
      path: '/forgot/password/:hash',
      name: 'fxView.ResetPasswordFromHash',
      component: ResetPasswordFromHash
    },
    {
      path: '/',
      component: fxViewcomponents,
      children: [
        {
          path: '/subscription-verify',
          name: 'fxView.subscription_verify',
          component: subscription_verify
        },
        //====================bank=================================================
        {
          path: BANK,
          name: 'fxView.bank',
          component: bank
        },
        {
          path: '/pending',
          name: 'fxView.later',
          component: later
        },
        //====================users=================================================
        {
          path: DASHBOARD,
          name: 'fxView.dashboard',
          component: dashboard
        },
        {
          path: '/change-password',
          name: 'fxView.changeUserPassword',
          component: changeUserPassword
        },
        {
          path: '/zulutrade',
          name: 'fxView.zuluTrade',
          component: zuluTrade
        },
        {
          path: PROFILE,
          name: 'fxView.profile',
          component: profile
        },
        {
          path: '/download-platform',
          name: 'fxView.downloadplatform',
          component: downloadplatform
        },
        {
          path: '/pro',
          name: 'fxView.pro',
          component: pro
        },
        {
          path: TWOFA,
          name: 'fxView.twoFa',
          component: twoFa
        },
        {
          path: NOTIFICATION,
          name: 'fxView.notification',
          component: notification
        },
        {
          path: REQUEST_VERIFY,
          name: 'fxView.request_verify',
          component: request_verify,
          props: true
        },
        {
          path: INDEX,
          name: 'fxView.welcome',
          component: welcome
        },
        //======================manage account=====================================
        {
          path: TRADER_CHANGE_PASSWORD,
          name: 'fxView.changePassword',
          component: changePassword
        },
        {
          path: CHANGE_LEVERAGE,
          name: 'fxView.changeLeverage',
          component: changeLeverage
        },
        {
          path: INTERNAL_TRANSFER,
          name: 'fxView.internalTransfer',
          component: internalTransfer
        },
        {
          path: ACCOUNT_LIST,
          name: 'fxView.accountList',
          component: accountList
        },
        {
          path: ACCOUNT_VERIFY,
          name: 'fxView.accountVerify',
          component: accountVerify
        },
        //======================trading account=====================================
        {
          path: OPEN_TRADES,
          name: 'fxView.openTradeList',
          component: openTradeList
        },
        {
          path: '/close-trades',
          name: 'fxView.closeTradeList',
          component: closeTradeList
        },
        {
          path: '/rest-api',
          name: 'fxView.rest_api',
          component: rest_api
        },
        {
          path: '/web-trade-link',
          name: 'fxView.web_trade_link',
          component: web_trade_link
        },
        {
          path: '/web-trade-link-live',
          name: 'fxView.web_trade_link_live',
          component: web_trade_link_live
        },
        {
          path: '/new-web-trade-link',
          name: 'fxView.web_trade_link_new',
          component: web_trade_link_new
        },
        {
          path: OPEN_ORDERS,
          name: 'fxView.openOrderList',
          component: openOrderList
        },
        {
          path: CREATE_LIVE_ACCOUNT,
          name: 'fxView.createAccountLive',
          component: createAccountLive,

        },
        {
          path: CREATE_DEMO_ACCOUNT,
          name: 'fxView.createAccountDemo',
          component: createAccountDemo
        },
        //======================withdrawal=========================================
        {
          path: WITHDRAWAL,
          name: 'fxView.withdrawal',
          component: withdrawal
        },
        {
          path: WITHDRAWAL_LIST,
          name: 'fxView.withdrawalList',
          component: withdrawalList
        },
        //======================deposit============================================
        {
          path: DEPOSIT,
          name: 'fxView.deposit',
          component: deposit
        },
        {
          path: DEPOSIT_LIST,
          name: 'fxView.depositList',
          component: depositList
        },
        {
          path: '/transaction-history',
          name: 'fxView.depositTransaction',
          component: depositTransaction
        },
        {
          path: '/paymentCallback',
          name: 'fxView.paymentCallback',
          component: paymentCallback
        },
        //=====================bonus===============================================
        {
          path: BONUS,
          name: 'fxView.bonus',
          component: bonus
        },
        {
          path: BONUS_LIST,
          name: 'fxView.bonusList',
          component: bonusList
        },
        {
          path: REMOVE_BONUS,
          name: 'fxView.removeBonus',
          component: removeBonus
        },
        {
          path: '/bonus-verify',
          name: 'fxView.bonusVerify',
          component: bonusVerify
        },
        //=====================supports============================================
        {
          path: SUPPORT,
          name: 'fxView.support',
          component: support
        },
        {
          path: VIEW,
          name: 'fxView.view',
          component: view
        },
        {
          path: '/unauthorized',
          name: 'fxView.unauthorized',
          component: unauthorized
        },
        {
          path: '/pending-verification',
          name: 'fxView.pendingVerification',
          component: pendingVerification
        },
        {
          path: '/minor/failed',
          name: 'fxView.failedTest',
          component: failedTest
        },
        //=====================Market subscription============================================
        {
          path: '/news',
          name: 'fxView.news',
          component: market_news
        },
        {
          path: '/tutorials',
          name: 'fxView.tutorials',
          component: video_tutorials
        },
        {
          path: '/market-insight',
          name: 'fxView.market_insight',
          component: market_insight
        },
        {
          path: '/subscription-tool',
          name: 'fxView.subscriptionTool',
          component: subscriptionTool
        },
        {
          path: '/market',
          name: 'fxView.market',
          component: market
        },
        {
          path: '/auto-chartist',
          name: 'fxView.autoChartist',
          component: autoChartist
        },
        {
          path: '/signal-centre',
          name: 'fxView.signalCentre',
          component: signalCentre
        },
        {
          path: '/trade-news',
          name: 'fxView.tradeNews',
          component: tradeNews
        },
        {
          path: '/create-subscription-ticket',
          name: 'fxView.createSubTicket',
          component: createSubTicket
        },
        {
          path: '/api-documentation',
          name: 'fxView.api_documentation',
          component: api_documentation
        },
        {
          path: '/plans',
          name: 'fxView.subscription_service_plan',
          component: subscription_service_plan
        },
        {
          path: '/economic-calendar',
          name: 'fxView.economic_calendar',
          component: economic_calendar
        },
        {
          path: '/vps-list',
          name: 'fxView.vpsList',
          component: vpsList
        },
        {
          path: '/vps-detail',
          name: 'fxView.vpsDetail',
          component: vpsDetail
        },
        {
          path: '/autochartist-scanner',
          name: 'fxView.autochartist_scanner',
          component: autochartist_scanner
        },
        {
          path: '/tradertool-box',
          name: 'fxView.tradertool_box',
          component: tradertool_box
        }
      ]
    }
  ]
})

function hasQueryParams(route) {
  return !!Object.keys(route.query).length
}

router.beforeEach((to, from, next) => {

  if (typeof window.fz === 'function') {
    if (!hasQueryParams(to) && hasQueryParams(from)) {
      window.fz("event", {name: "pageView", value: window.location.hostname+to.path, unit: "url"});
    } else {
      window.fz("event", {name: "pageView", value: window.location.hostname+to.path, unit: "url"});
    }
  } else {
    console.error("window.fz is not a function");
  }
  
  let userStateVariable = store.state.user
  if (userStateVariable == '') {
    userStateVariable = {}
  }
  if(to.query.auth){
    localStorage.setItem("temp_token", to.query.auth);
    localStorage.setItem("temp_query", JSON.stringify(to.query));
  }
  if (to.name !== 'fxView.login' && to.name !== 'fxView.register' && to.name !== 'fxView.forgotPassword' && to.name !== 'fxView.ResetPasswordFromHash' && ((userStateVariable == null || !'loggedIn' in userStateVariable) || !userStateVariable.loggedIn)){
      localStorage.setItem("lastPath", to.path);
      next({ name: 'fxView.login' })
  }
  //if the user is not authenticated, `next` is called twice
  else if (userStateVariable !== null && 'loggedIn' in userStateVariable && userStateVariable.loggedIn && (to.name == 'fxView.createAccountLive' || to.name == 'fxView.rest_api' || to.name == 'fxView.deposit') && userStateVariable.step != 5 ) next({ name: 'fxView.welcome' })

  else if (userStateVariable !== null && 'loggedIn' in userStateVariable && userStateVariable.loggedIn && to.name == 'fxView.pro' && parseInt(userStateVariable.verified_status) != 1) next({ name: 'fxView.welcome' })

  else if (userStateVariable !== null && 'loggedIn' in userStateVariable && userStateVariable.loggedIn && (to.name == 'fxView.createAccountLive' || to.name == 'fxView.welcome' || to.name == 'fxview.rest_api') && userStateVariable.step > 2 && userStateVariable.profile.total_points <= 2) next({ name: 'fxView.failedTest' })

  else if (userStateVariable !== null && 'loggedIn' in userStateVariable && userStateVariable.loggedIn && to.name == 'fxView.welcome' && userStateVariable.step > 4) next({ name: 'fxView.dashboard' })
  else if (userStateVariable !== null && 'loggedIn' in userStateVariable && userStateVariable.loggedIn && (to.name == 'fxView.createAccountLive' || to.name == 'fxView.deposit') && parseInt(userStateVariable.verified_status) != 1) next({ name: 'fxView.dashboard' })

  else if (userStateVariable !== null && 'loggedIn' in userStateVariable && userStateVariable.loggedIn && (to.name == 'fxView.login' || to.name == 'fxView.register' || to.name == 'fxView.forgotPassword' || to.name == 'fxView.ResetPasswordFromHash')) next({ name: 'fxView.dashboard' })

  else next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js